import { preparePhone } from './preparePhone';
import { IRegion } from '../../../types/requestForm/requestFormV2';

export const prepareTrackingParams = (values: { phone: string; region: IRegion; requirements: string }) => {
  return {
    phone: preparePhone(values.phone),
    regionId: (values.region as IRegion).id,
    regionName: (values.region as IRegion).label,
    searchWishes: values.requirements.trim() || undefined,
  };
};
